var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 7.5C16.5796 7.5 15.8331 8.24652 15.8331 9.16699V11.667C15.8331 14.3333 15.833 15.6663 15.045 16.5264C14.986 16.5907 14.9247 16.653 14.8604 16.7119C14.0003 17.5001 12.6667 17.5 10.0001 17.5C7.33342 17.5 5.99984 17.5001 5.13971 16.7119C5.07539 16.653 5.01408 16.5907 4.95514 16.5264C4.16709 15.6663 4.16705 14.3333 4.16705 11.667V9.16699C4.16705 8.24652 3.42054 7.5 2.50006 7.5V5H17.5001V7.5ZM7.91705 8.16699C7.36477 8.16699 6.91705 8.61471 6.91705 9.16699V13.334C6.91741 13.886 7.36499 14.334 7.91705 14.334C8.46897 14.3338 8.9167 13.8859 8.91705 13.334V9.16699C8.91705 8.61482 8.46919 8.16717 7.91705 8.16699ZM12.084 8.16699C11.5318 8.16699 11.084 8.61471 11.084 9.16699V13.334C11.0844 13.886 11.532 14.334 12.084 14.334C12.6358 14.3336 13.0837 13.8858 13.084 13.334V9.16699C13.084 8.61492 12.636 8.16734 12.084 8.16699Z",
    fill: "#9061DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39014 2.80883C8.4851 2.72023 8.69434 2.64194 8.98542 2.5861C9.27649 2.53027 9.63313 2.5 10 2.5C10.3669 2.5 10.7235 2.53027 11.0146 2.5861C11.3057 2.64194 11.5149 2.72023 11.6099 2.80883",
    stroke: "#9061DB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.e2ba0ae2faab39d449e15dab9bdc0ea3.svg";
export { ForwardRef as ReactComponent };